import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, DialogActions, IconButton, Menu, MenuItem, ListItemIcon, Tooltip, Typography } from "@mui/material";
import { Download } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import { useDispatch, useSelector } from "react-redux";

export default function HeaderSession(props) {
    const departamento = useSelector(state => state.account.user?.departamento);
    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = useState(null);
    const tituloRef = useRef(null);
    const dispatch = useDispatch();
    const url = useLocation();


    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         ([entry]) => {
    //             if (!entry.isIntersecting && props?.title) {
    //                 // quando o título encosta no topo
    //                 dispatch({
    //                     type: "title",
    //                     payload: { title: props?.title },
    //                 })
    //             } else {

    //                 dispatch({
    //                     type: "title",
    //                     payload: { title: `GESTOR - ARMED / ${departamento}` },
    //                 });
    //             }
    //         },
    //         { threshold: 0.0 }
    //     );

    //     if (tituloRef.current) {
    //         observer.observe(tituloRef.current);
    //     }

    //     return () => {
    //         if (tituloRef.current) {
    //             observer.unobserve(tituloRef.current);
    //         }
    //     };
    // }, [props?.title, departamento, dispatch, tituloRef.current, url.pathname]);

    return (
        <>
            <Box sx={{ display: "flex" }}>
                <Typography variant="h1" ref={tituloRef} style={{ margin: 20, fontSize: 23, display: 'flex', alignItems: 'center', flexGrow: 1, }}>
                    <IconButton onClick={() => navigate(-1)} style={{ marginRight: 15, }} title='Voltar'>
                        <img width={20} src="/img/icones/setaback1.svg" alt="" />
                    </IconButton>
                    <span translate="no">
                        {props?.maiusculo ? props.title?.toUpperCase() : props.title}
                    </span>
                </Typography>

                {props.actions &&
                    <DialogActions >

                        <Tooltip title="Opções para Baixar">
                            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                                <Download />
                            </IconButton>
                        </Tooltip>

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}
                        >
                            <MenuItem onClick={props.handleExportExcel}>
                                <ListItemIcon>
                                    <DownloadIcon color="secondary" />
                                </ListItemIcon>
                                Baixar Excel
                            </MenuItem>
                            <MenuItem onClick={props.handleExportPDF}>
                                <ListItemIcon>
                                    <DownloadIcon color="secondary" />
                                </ListItemIcon>
                                Baixar PDF
                            </MenuItem>
                        </Menu>

                    </DialogActions>
                }

            </Box>

            <hr style={{ border: '1px solid #c43ab9' }} />
            <br />
        </>

    )
}
